<template>
  <main-layout :selectedMenu="'activity'">
    <div>
      <div class="banner">
      </div>
      <div class="content1">
        <div class="head">
          {{$t('global.填写报名信息')}}
        </div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.作品名称')}}</div>
            <input type="text"
                   class="resetW"
                   :placeholder="$t('global.请输入您的作品名字')">
          </div>
        </div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.视频简介')}}</div>
            <textarea class="resetW"></textarea>
          </div>
        </div>

        <div class="upcontent">
          <div class="upload"
               :style="images | bgImageUrl">
            <div class="add-wrap"><img src="/static/uploadvideo/add.png"
                                       alt=""
                                       class="add">
              <div class="font">{{$t('global.上传参赛视频')}}</div>
            </div>
          </div>
          <div class="upload"
               :style="images | bgImageUrl">
            <div class="add-wrap"><img src="/static/uploadvideo/add.png"
                                             alt=""
                                             class="add">
              <div class="font">{{$t('global.上传作品封面')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit">{{$t('global.提交')}}</div>

      <service />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout"
import service from '../components/service.vue'

export default {
  name: 'competitionUpVideo',
  metaInfo() {
    return {
      title: this.$t("global.上传比赛视频") + " | MANA"
    };
  },
  components: {
    service,
    MainLayout
  },
  data() {
    return {
      images:''
    }
  }
}
</script>
<style lang="stylus" scoped>
.submit
  display block
  width: 3.57rem;
  height: 0.46rem;
  margin:0.5rem auto 0.8rem;
  line-height 0.6rem
  text-align center
  border-radius: 0.23rem;
  border: solid 1px #0161ff;
.upcontent
  display flex
  padding-top 0.32rem
  justify-content space-between
.upload
  width 3.8rem
  height 3.73rem
  background-repeat no-repeat
  background-size 3.8rem 3.73rem
  box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.1)
  border-radius 0.08rem
  margin-top 0.6rem
.add-wrap
  width 3.6rem
  height 3.53rem
  margin 0.1rem
  border-radius 0.08rem
  border dashed 2px #dddddd
  .add
    display block
    width 0.8rem
    height 0.8rem
    margin 1.36rem auto 0.32rem
  .font
    color #333333
    text-align center
    font-size 0.22rem
.upload-wrap
  height 6.32rem
  padding 0 3rem
  margin-top 0.2rem
  overflow hidden
  background-color #ffffff
  .up-head
    color #000000
    font-size 0.2rem
    margin-top 0.5rem
    span
      color #999999
      font-size 0.16rem
  .upcontent
    display flex
    padding-top 0.32rem
    justify-content space-between
  .modify-btn
    width 1.55rem
    height 0.46rem
    margin 0.3rem auto 0
    line-height 0.46rem
    font-size 0.18rem
    text-align center
    color #0161ff
    cursor pointer
    border-radius 0.23rem
    border solid 1px #0161ff
.font
  color #000000
  font-size 0.2rem
.contain
    display flex
    justify-content space-between
    margin-top 0.56rem
    input, select,textarea
        width 6rem
        height 0.5rem
        margin-top 0.1rem
        background-color #F9F9F9
        border-radius 0.08rem
        text-indent 0.1rem
        outline none
        border none
    textarea
        height 2.7rem
    .resetW
        width 10rem
.banner
    width 100%
    height 6rem
    background url('/static/activity/signBanner.png') no-repeat
    background-size 100%
.content1
    width 10rem
    margin 0.4rem auto 0
    padding 0.6rem 3rem
    background-color #ffffff
    .content
        margin-top 0.2rem
        color #707070
        font-size 0.16rem
        line-height 0.36rem
    .tilte
        font-size 0.2rem
        color #000000
        margin-top 0.5rem
    .head
        font-weight bold
        text-align center
        font-size 0.26rem
        color #333333
</style>




// WEBPACK FOOTER //
// src/pages/competitionUpVideo.vue